import { Popover } from '@mui/material';
import type { ReactNode } from 'react';
import { cn } from 'utils/classNamesTailwind';
import { selectDropdownPaperVariants } from './select/selectVariants';

interface SelectDropdownProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: ReactNode;
  id?: string;
  paperClassName?: string;
  mode?: 'flat' | 'tree';
  minWidth?: number;
  fitContent?: boolean;
}

export function SelectDropdown({
  open,
  anchorEl,
  onClose,
  children,
  id = undefined,
  paperClassName = '',
  mode = 'flat',
  minWidth = 270,
  fitContent = false,
}: SelectDropdownProps) {
  return (
    <Popover
      id={id ? `${id}-dropdown` : undefined}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{
        paper: {
          className: cn(selectDropdownPaperVariants({ mode }), paperClassName),
          style: fitContent
            ? { width: 'max-content', minWidth: Math.max(anchorEl?.offsetWidth ?? 0, minWidth) }
            : { width: Math.max(anchorEl?.offsetWidth ?? 0, minWidth) },
        },
      }}
    >
      {children}
    </Popover>
  );
}
